import { SharedState } from '$utils/sharedState.svelte';

class StateIsOnline extends SharedState<boolean> {}

export const stateIsOnline = new StateIsOnline(true);
